import { create } from 'zustand';

interface PortalState {
  selectedSectionId: string | null;
  editingNodeId: string | null;
  setSelectedSection: (id: string | null) => void;
  setEditingNode: (id: string | null) => void;
}

export const usePortalStore = create<PortalState>((set) => ({
  selectedSectionId: null,
  editingNodeId: null,
  setSelectedSection: (id) => set({ selectedSectionId: id }),
  setEditingNode: (id) => set({ editingNodeId: id }),
}));
